import {LEGAL_VERSION,LEGAL_DATE} from '../../legal/privacyContent';
import React, { useEffect, useState } from "react";
import "./PrivacyBanner.css";

const PrivacyBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("privacyBannerDismissed");
    if (dismissed !== LEGAL_VERSION) {
      setShowBanner(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem("privacyBannerDismissed", LEGAL_VERSION);
    setShowBanner(false);
  };

  return showBanner ? (
    <div className="privacy-banner">
      <p>
        Our privacy notice was updated on {LEGAL_DATE}. Valovate uses browser storage and cloud services for accounts, drafts,
        security, and team features. Optional YouTube playback and TikTok embeds
        involve third-party data collection and cookies. YouTube loads after its
        player prompt; TikTok embeds can load as you approach the socials video
        section. Dismissing this notice does not grant optional player or marketing
        consent. See our Privacy Policy for details.
      </p>

      <div className="privacy-buttons">
        <button onClick={handleClose}>Dismiss</button>

        <a href="/privacy-policy" className="learn-more">
          Privacy Policy
        </a>

        <a href="/terms-of-service" className="learn-more">
          Terms
        </a>
      </div>
    </div>
  ) : null;
};

export default PrivacyBanner;
